import React, { useContext, useState } from "react"
import {
  Modal,
  Input,
} from "../ui_new"
import { CheckCircle, Close } from "../../assets/icons"
import { Cancel } from "@mui/icons-material"
import { NotificationContext } from "../../context"

const ValidationSubmitModal = ({
  onCancel,
  validation,
  action,
  onSubmit,
}) => {
  
  const { setNotification } = useContext(NotificationContext)
  // const { document } = useContext(SingleDocumentContext)
  const [comment, setComment] = useState('')

  const handleCancel = () => {
    onCancel()
  }

  const handleConfirm = () => {
    if(action === 'refuse' && !comment.trim()) {
      setNotification({ msg: "Le commentaire ne peut pas être vide", type: 'danger' })
      return
    }
    onSubmit(validation, action, comment.trim())
  }

  const title = 'Mode révision'

  const descriptionText =
    action === 'validate' ?
      `Vous êtes sur le point de valider le document ${validation?.documentName}, le négociateur pourra ainsi le transmettre au client. Vous pouvez y ajouter un commentaire général ci-dessous afin d’apporter d’autres informations au négociateur.` :
    action === 'refuse' ?
      `Vous êtes sur le point de refuser le document ${validation?.documentName}. Vous devez y ajouter un commentaire général ci-dessous afin d’apporter d’autres informations au négociateur.` :
    'Invalid action'

  const questionText = 
    action === 'validate' ?
      'Confirmez-vous la validation du document ?' :
    action === 'refuse' ?
      'Confirmez-vous le refus du document ?' :
    'Invalid action'

  const cancelLabel = 'Annuler'

  const confirmLabel = 'Valider'

  return (
    <Modal onClose={onCancel} className="modal-v2 modal-v2--medium">
      <div className="modal-v2__heading modal-v2__heading--light modal-v2__heading--small">
        <h2>{title}</h2>
        <div className="buttons-row">
          <button
            className="btn btn--small btn--light btn--border-primary btn--border-radius-sm btn--square"
            onClick={onCancel}
          >
            <Close />
          </button>
        </div>
      </div>
      <div className="modal-v2__body">
        <div className="description-box">
          {descriptionText && <p className="share-warning--text">{descriptionText}</p>}
          {questionText && <p className="share-warning--question">{questionText}</p>}
        </div>
        <div className="description-box">
          <Input
            label="Ajouter un commentaire général"
            placeholder=" - "
            type="text"
            className="input--border-radius-sm"
            value={comment}
            required={action === 'refuse'}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <div className="modal-v2__buttons-footer">
          {cancelLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-danger"
              onClick={handleCancel}
            >
              <Cancel fontSize="small" />
              {cancelLabel}
            </button>
          )}
          {confirmLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-success"
              onClick={handleConfirm}
            >
              <CheckCircle />
              {confirmLabel}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ValidationSubmitModal
